export default () => {
  return {
    content: {
      html_formatter: 'mustache',
    },
  };
};
